var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height"},[_c('GridChartCard',{attrs:{"title":_vm.title,"canvasId":_vm.elementId,"containerId":_vm.containerId,"downloadCSV":"","hasData":_vm.xValues.length > 0,"noDataText":_vm.noDataText},on:{"download-csv":_vm.exportCSV,"draw":_vm.createChart}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }